import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Editor as H5Editor } from "../H1Block/Editor";
import { H5 } from "./H5Block";
import { defaultData } from "./H5BlockDefaultData";
import { meta } from "./H5BlockMetaData";

export const H5Block: BlockExport = {
  type: "component",
  Block: H5,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-heading",
    size: 24,
  },
  Editor: H5Editor,
  defaultData,
  meta,
};
